import type { ComponentProps, ReactNode } from "react";
import { Link } from "react-router";
import ConditionalComponent from "../common/ConditionalComponent";

interface ButtonProps extends ComponentProps<"button"> {
    submit?: boolean;
    size?: "small" | "large" | "";
    secondary?: boolean;
    link?: boolean;
    fullWidth?: boolean;
    imgIcon?: string;
    to?: string;
    children?: ReactNode;
    cursor?: "pointer" | "default";
    ariaLabel?: string;
    "aria-label"?: string;
}

const Button = ({
    submit = false,
    size = "",
    secondary = false,
    link = false,
    fullWidth = false,
    imgIcon,
    to,
    children,
    disabled = false,
    className,
    cursor,
    ariaLabel,
    "aria-label": ariaLabelDash,
    ...buttonProps
}: ButtonProps) => {
    const isLink = to && !disabled;
    const accessibleName = ariaLabel || ariaLabelDash;

    return (
        <ConditionalComponent
            condition={isLink === true && to !== undefined}
            wrapper={(children) => <Link to={to!}>{children}</Link>}
        >
            <button
                {...buttonProps}
                type={submit || buttonProps.type === "submit" ? "submit" : "button"}
                className={`${link ? "btn-link" : "btn"} ${
                    size === "small" ? (isLink ? "btn-link-sm" : "btn-sm") : ""
                } ${size === "large" ? (isLink ? "btn-link-lg" : "btn-lg") : ""} ${secondary ? "btn-secondary" : ""} ${
                    fullWidth ? "w-full" : ""
                } ${cursor ? `cursor-${cursor}` : !disabled ? "cursor-pointer" : ""} ${className || ""}`.trim()}
                disabled={disabled}
                aria-label={accessibleName}
            >
                <div className="button-content-wrapper">
                    {imgIcon && <img src={imgIcon} alt={accessibleName || "Button icon"} className="button-img-icon" />}
                    {children}
                </div>
            </button>
        </ConditionalComponent>
    );
};

export default Button;
